
import CellBox from 'vux/src/components/cell-box/index.vue'

import props from './props'

export default {
components: {
CellBox
},
props: props(),
data () {
return {
hasFullHeightSlot: false,
hasRightSlot: false
}
},
beforeMount () {
if (this.$slots && this.$slots['restricted-label']) {
this.hasRestrictedLabel = true
}
if (this.$slots && this.$slots['full-height']) {
this.hasFullHeightSlot = true
}
if (this.$slots && this.$slots['right-content']) {
this.hasRightSlot = true
}
}
}



// WEBPACK FOOTER //
// ./src/components/common/cell-placeholder/index.vue